/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_WebInputs */

const cs_enum_web = /** @type {(inputs: Enum_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web`)
};

const en_enum_web = /** @type {(inputs: Enum_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web`)
};

/**
* | output |
* | --- |
* | "Web" |
*
* @param {Enum_WebInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_web = /** @type {((inputs?: Enum_WebInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_WebInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_web(inputs)
	return cs_enum_web(inputs)
});